import { Component } from '@angular/core';

@Component({
  selector: 'app-change-log',
  templateUrl: './change-log.component.html',
  styleUrls: ['./change-log.component.css'],
  preserveWhitespaces: true,
})
export class ChangeLogComponent {}
